import { Box, Breadcrumbs, Link, Skeleton, Typography } from '@mui/material';
import { last } from 'lodash';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Separator = <Box component='span' sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'text.disabled' }} />;

interface Link {
    href: string;
    name?: string;
    icon?: string;
}

interface LinkItemProps {
    link: Link;
}

// TODO: Create a separate component
const LinkItem: React.FunctionComponent<LinkItemProps> = ({ link }) => {
    const { href, name, icon } = link;
    return (
        <Link
            to={href}
            key={name}
            variant='body2'
            component={RouterLink}
            sx={{
                lineHeight: 2,
                display: 'flex',
                alignItems: 'center',
                color: 'text.primary',
                '& > div': { display: 'inherit' },
            }}
        >
            {icon && (
                <Box
                    sx={{
                        mr: 1,
                        '& svg': { width: 20, height: 20 },
                    }}
                >
                    {icon}
                </Box>
            )}
            {name}
        </Link>
    );
};

interface MBreadcrumbsProps {
    links: Link[];
    activeLast?: boolean;
}

const MBreadcrumbs: React.FunctionComponent<MBreadcrumbsProps> = ({ links, activeLast = false, ...other }) => {
    const currentLink = last(links)?.name;

    const listDefault = links.map(link => <LinkItem key={link.name} link={link} />);
    const listActiveLast = links.map(link => (
        <div key={link.href}>
            {link.name !== currentLink ? (
                <LinkItem link={link} />
            ) : (
                <Typography
                    variant='body2'
                    sx={{
                        maxWidth: 260,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        color: 'text.disabled',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {currentLink || <Skeleton width={130} />}
                </Typography>
            )}
        </div>
    ));

    return (
        <Breadcrumbs separator={Separator} {...other}>
            {activeLast ? listDefault : listActiveLast}
        </Breadcrumbs>
    );
};

export default MBreadcrumbs;
